import * as React from 'react';

var Direction = /*#__PURE__*/function (Direction) {
  Direction["LTR"] = "ltr";
  Direction["RTL"] = "rtl";
  return Direction;
}(Direction || {});
var defaultLocale = 'en-us';
var defaultValue = {
  direction: Direction.LTR,
  locale: defaultLocale
};
var LocaleContext = /*#__PURE__*/React.createContext(defaultValue);
var useDirectionContext = function useDirectionContext() {
  var _React$useContext = React.useContext(LocaleContext),
    direction = _React$useContext.direction;
  return direction;
};
var useLocaleContext = function useLocaleContext() {
  return React.useContext(LocaleContext);
};
var LocaleContextProvider = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? defaultValue : _ref$value;
  return /*#__PURE__*/React.createElement(LocaleContext.Provider, {
    value: value
  }, children);
});
LocaleContextProvider.displayName = 'LocaleContextProvider';

export { Direction, LocaleContextProvider, defaultValue as defaultDirection, useDirectionContext, useLocaleContext };
//# sourceMappingURL=Locale.js.map
